module.exports = __webpack_public_path__ + "img/425-472-mobile.8b8d656.webp";